"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressType = void 0;
var AddressType;
(function (AddressType) {
    AddressType["Residential"] = "RESIDENTIAL";
    AddressType["Commercial"] = "COMMERCIAL";
})(AddressType || (exports.AddressType = AddressType = {}));
//# sourceMappingURL=address.js.map